import { languageCheck } from "@shared/functions";
import React from "react";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

interface CardHeaderProps {
  title: string;
  postIndex: number;
  setPostIndex: (value: number) => void;
  postsLength: number;
}

export const PostHeaderSearch = ({
  title,
  postIndex,
  setPostIndex,
  postsLength,
}: CardHeaderProps) => {
  const handlePrevPost = () => {
    postIndex === 0
      ? setPostIndex(postsLength - 1)
      : setPostIndex(postIndex - 1);
  };

  const handleNextPost = () => {
    let prevIndex = postIndex;
    postsLength === prevIndex + 1
      ? setPostIndex(0)
      : setPostIndex(prevIndex + 1);
  };

  return (
    <div className="flex items-center justify-center h-[20%] w-full mt-2">
      <div className="flex items-center justify-between w-[85%] text-center">
        {/* <div className="min-w-4">
          <IoChevronBack
            className="cursor-pointer text-primary-color"
            size={26}
            onClick={() => handlePrevPost()}
          />
        </div> */}
        <div className="px-2 py-1 text-[12px] font-semibold flex-1 text-white rounded-full">
          {title?.toUpperCase()}
        </div>
        {/* <div className="min-w-4">
          <IoChevronForward
            className="cursor-pointer text-primary-color"
            size={26}
            onClick={() => handleNextPost()}
          />
        </div> */}
      </div>
    </div>
  );
};
